import React, { Component } from 'react';
import Button from '~/UI/Button';
import menuItemDestructiveButtonStyles from '~/UI/Button/menu-destructive-item.less';
import menuItemButtonSecondaryStyles from '~/UI/Button/menu-item-secondary.less';
import menuItemButtonStyles from '~/UI/Button/menu-item.less';
import Popover from '~/UI/Popover';
import styles from '~/UI/Popover/default.less';

interface Props {
	referenceRect: ClientRect | null;
	onCopy(): void;
	onRename(): void;
	onDelete(): void;
	onClose(event: MouseEvent): void;
}

export default class OptionsPopover extends Component<Props> {
	static defaultProps = {
		referenceRect: null,
	};

	render() {
		const { referenceRect, onCopy, onRename, onDelete, onClose } = this.props;

		if (!referenceRect) {
			return null;
		}

		return (
			<Popover referenceRect={referenceRect} width={220} onClose={onClose}>
				<div className={styles.row}>
					<Button styles={menuItemButtonSecondaryStyles} onClick={onCopy}>
						Copy
					</Button>
				</div>
				<div className={styles.row}>
					<Button styles={menuItemButtonStyles} onClick={onRename}>
						Rename
					</Button>
				</div>
				<div className={styles.row}>
					<Button styles={menuItemDestructiveButtonStyles} onClick={onDelete}>
						Delete
					</Button>
				</div>
			</Popover>
		);
	}
}
